export interface IOfferGeo {
  /** географические координаты объекта размещения */
  coordinates: ICoordinates;
  /** цепочка ID объектов адреса (от ) */
  locationPath: Array<number>;
  /** цепочка адреса по геосущностям */
  details: TGeoDetails;
  /** станции метро */
  undergrounds: TOfferUndergrounds | null;
  /** шоссе */
  highways: TOfferHighways | null;
  /** жилой комплекс */
  jk?: IJK;
  /** адрес в упрощённом виде */
  address: Array<IGeoAddress>;
  /** адрес в упрощённом виде */
  userInput: string;
  /** ограничения редактирования адреса */
  editRestriction: IOfferGeoEditRestriction | null;
}

export interface ICoordinates {
  /** широта */
  lat: number;
  /** долгота */
  lng: number;
}

export type TGeoDetails = Array<IGeoDetail>;

export interface IGeoDetail {
  /** флаг необходимости указывать улицу */
  streetRequired: boolean;
  /** тип геосущности */
  geoType: EGeoDetailType;
  /** флаг наличия метро */
  hasMetro: boolean;
  /** краткое название геосущности */
  name: string;
  /** флаг района (не используется на ФП) */
  isLocality: boolean;
  /** ID типа геосущности */
  locationTypeId?: number;
  /** полное название геосущности */
  fullName: string;
  /** ID геосущности */
  id: number;
  /** то ли шоссе, то ли ЖД (не используется на ФП) */
  hasRoad: boolean;
}

export interface IJK {
  /** id жилого комплекса */
  id: number;
  /** название ЖК */
  name: string | null;
  /** дом жилого комплекса */
  house: IJKHouse;
  /** данные о застройщике ЖК */
  developer: IJKDeveloper | null;
}

export interface IJKHouse {
  /** id дома жилого комплекса */
  id: number;
}

export interface IJKDeveloper {
  /** id застройщика */
  id: number | null;
  /** название застройщика */
  name: string | null;
}

export type TOfferUndergrounds = Array<IOfferUnderground>;

export interface IOfferUnderground {
  /** id станции метро */
  id: number;
  /** название станции метро */
  name: string | null;
}

export type TOfferHighways = Array<IOfferHighway>;

export interface IOfferHighway {
  /** id шоссе */
  id: number | null;
  /** название шоссе */
  name: string | null;
  /** расстояние до шоссе */
  distance: number | null;
  /** шоссе по умолчанию */
  isDefault: boolean;
  /** уникальный идентификатор */
  uuid: string;
}

export interface IGeoAddress {
  id: number;
  type: EGeoDetailType;
}

export enum EGeoDetailType {
  location = 'location',
  street = 'street',
  house = 'house',
}

export interface IOfferGeoEditRestriction {
  isRestricted: boolean;
  message: string;
}
